export default __webpack_public_path__ + "static/media/doral-urban.b029b249.png";